import { Attributes, Misc, ModelBase, NeoModel } from "@singularsystems/neo-core";

@NeoModel
export default class CreateExportFileSpecCommand extends ModelBase {
    
    public exportName: string = "";

    public exportReportReference: string = "";

    public format: string = "";

    @Attributes.Date(Misc.TimeZoneFormat.None)
    public activeStartDate: Date | null = null;

    @Attributes.Date(Misc.TimeZoneFormat.None)
    public activeEndDate: Date | null = null;

    public isCreatedFromPreviousVersion: boolean = false;

    public latestFileSpecVersionId: number = 0;
}